import bombay from "./bombay.png";
import christmas from "./christmasEve.png";
import honeybee from "./honeybee.png";
import mamas_birthday from "./mamasBirthday.png";
import sprayed_by_skunk from "./skunk.png";
import the_moon from "./theMoon.png";
import undercover_spy from "./undercover_spy.png";
import we_share_the_same_sky from "./weShare.png";

const IMAGES = {
    BOMBAY: bombay,
    CHRISTMAS: christmas,
    HONEYBEE: honeybee,
    MAMAS_BIRTHDAY: mamas_birthday,
    SPRAYED_BY_SKUNK: sprayed_by_skunk,
    THE_MOON_PERHAPS: the_moon,
    UNDERCOVER_SPY: undercover_spy,
    WE_SHARE_THE_SAME_SKY: we_share_the_same_sky,
};

export default IMAGES;
